import { ContentBlock } from '../components'

const PreShipNotice = () => (
  <ContentBlock title="You're all set!">
    We have everything we need to ship your pump and we will submit your claim
    to insurance at that time.
  </ContentBlock>
)

export default PreShipNotice
